import { useRef } from 'react'
import { motion } from 'framer-motion'

import s1 from '../assests/prewedding_webp/0007.webp'
import s2 from '../assests/prewedding_webp/00A_A2.webp'
import s3 from '../assests/prewedding_webp/0017.webp'
import s4 from '../assests/wedding_webp/00_30A7708.webp'
import s5 from '../assests/prewedding_webp/0014.webp'
import s6 from '../assests/babyshower_webp/20.webp'

import s11 from '../assests/wedding_webp/003.webp'
import s12 from '../assests/wedding_webp/S_S.webp'
import s13 from '../assests/prewedding_webp/0013.webp'
import s14 from '../assests/prewedding_webp/0011.webp'
import s15 from '../assests/prewedding_webp/0016.webp'
import s16 from '../assests/babyshower_webp/00v2.webp'

function InfiniteScroll() {
  const row1Ref = useRef(null)
  const row2Ref = useRef(null)

  // Images data with different aspect ratios
  const images1 = [
    { src: s11, aspectRatio: "square" },
    { src: s1, aspectRatio: "rectangle" },
    { src: s12, aspectRatio: "square" },
    { src: s2, aspectRatio: "rectangle" },
    { src: s13, aspectRatio: "square" },
    { src: s3, aspectRatio: "rectangle" },
  ]

  const images2 = [
    { src: s4, aspectRatio: "rectangle" },
    { src: s14, aspectRatio: "square" },
    { src: s5, aspectRatio: "rectangle" },
    { src: s15, aspectRatio: "square" },
    { src: s6, aspectRatio: "rectangle" },
    { src: s16, aspectRatio: "square" },
  ]

  return (
    <><div className="mt-5 lg:mb-0">
      <h2 style={{ fontWeight: '400' , width:'100%' , textAlign:'center' }} className="text-4xl font-fontc text-gray-900 mb-4 md:text-5xl">
      Our Gallery of Timeless Moments
      </h2>
    </div><div className="mb-10 w-full overflow-hidden py-8">
        {/* First Row - Left to Right */}
        <div className="relative mb-4">
          <div className="absolute left-0 top-0 z-10 h-full w-12 sm:w-16 bg-gradient-to-r from-white to-transparent" />
          <div className="absolute right-0 top-0 z-10 h-full w-12 sm:w-16 bg-gradient-to-l from-white to-transparent" />
          <motion.div
            ref={row1Ref}
            className="flex gap-2 sm:gap-4"
            animate={{
              x: [0, -1920],
            }}
            transition={{
              duration: 35,
              repeat: Infinity,
              ease: "linear",
            }}
          >
            {/* Double the images for seamless loop */}
            {[...images1, ...images1].map((image, idx) => (
              <div
                key={idx}
                className={`relative flex-shrink-0 overflow-hidden rounded-lg ${image.aspectRatio === 'square' ? 'h-40 w-40 sm:h-64 sm:w-64' : 'h-40 w-60 sm:h-64 sm:w-96'}`}
              >
                <img loading='lazy'
                  src={image.src}
                  alt={`Carousel ${idx + 1}`}
                  className="h-full w-full object-cover" />
              </div>
            ))}
          </motion.div>
        </div>

        {/* Second Row - Right to Left */}
        <div className="relative">
          <div className="absolute left-0 top-0 z-10 h-full w-12 sm:w-16 bg-gradient-to-r from-white to-transparent" />
          <div className="absolute right-0 top-0 z-10 h-full w-12 sm:w-16 bg-gradient-to-l from-white to-transparent" />
          <motion.div
            ref={row2Ref}
            className="flex gap-2 sm:gap-4"
            animate={{
              x: [-1920, 0],
            }}
            transition={{
              duration: 35,
              repeat: Infinity,
              ease: "linear",
            }}
          >
            {/* Double the images for seamless loop */}
            {[...images2, ...images2].map((image, idx) => (
              <div
                key={idx}
                className={`relative flex-shrink-0 overflow-hidden rounded-lg ${image.aspectRatio === 'square' ? 'h-40 w-40 sm:h-64 sm:w-64' : 'h-40 w-60 sm:h-64 sm:w-96'}`}
              >
                <img
                  loading='lazy'
                  src={image.src}
                  alt={`Carousel ${idx + 1}`}
                  className="h-full w-full object-cover" />
              </div>
            ))}
          </motion.div>
        </div>
      </div></>
  )
}



export default InfiniteScroll;



